import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import Login from './views/Login.vue'
import SSOCallback from './views/SSOCallback.vue'
import LabLayout from './views/LabLayout.vue'
import UploadChoice from './views/UploadChoice.vue'
import SingleFileUpload from './views/subject/SingleFileUpload.vue'
import CohortUpload from './views/cohort/CohortUpload.vue'
import CohortDashboard from './views/cohort/CohortDashboard.vue'
import SubjectDashboard from './views/subject/SubjectDashboard.vue'
import Explorer from './views/subject/Explorer.vue'
import AdherenceReport from './views/subject/AdherenceReport.vue'
import CurveResults from './views/subject/CurveResults.vue'
import TempMotionResults from './views/subject/TempMotionResults.vue'
import CompletedJobs from './views/CompletedJobs.vue'
import Billing from './views/Billing.vue'
import SetLabDefaults from './views/SetLabDefaults.vue'
import DemoShell from './views/demo/DemoShell.vue'
import DemoUpload from './views/demo/DemoUpload.vue'
import DemoSubjectDashboard from './views/demo/DemoSubjectDashboard.vue'
import DemoExplorer from './views/demo/DemoExplorer.vue'
import DemoAdherenceReport from './views/demo/DemoAdherenceReport.vue'
import DemoCurveResults from './views/demo/DemoCurveResults.vue'
import DemoTempMotionResults from './views/demo/DemoTempMotionResults.vue'
import { createAuthGuard } from './router/authGuard.js'
import './style.css'

// Lab UI: /maptac/:labId/... Legacy paths without /maptac are rewritten in beforeEach.
const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    { path: '/', redirect: '/maptac/login' },
    {
      path: '/login',
      redirect: (to) => ({ path: '/maptac/login', query: to.query, hash: to.hash })
    },
    {
      path: '/maptac/login',
      name: 'Login',
      component: Login,
      meta: { requiresAuth: false }
    },
    {
      path: '/auth/callback',
      name: 'SSOCallback',
      component: SSOCallback,
      meta: { requiresAuth: false }
    },
    {
      // Single shared Duo redirect (Option A); lab from lab-users.json + state, not the path
      path: '/maptac/auth/callback',
      name: 'SSOCallbackMaptac',
      component: SSOCallback,
      meta: { requiresAuth: false }
    },
    {
      path: '/maptac/demo',
      component: DemoShell,
      meta: { requiresAuth: false },
      children: [
        {
          path: '',
          name: 'DemoUpload',
          component: DemoUpload,
          meta: { requiresAuth: false }
        },
        {
          path: 'dashboard',
          name: 'DemoSubjectDashboard',
          component: DemoSubjectDashboard,
          meta: { requiresAuth: false }
        },
        {
          path: 'explorer',
          name: 'DemoExplorer',
          component: DemoExplorer,
          meta: { requiresAuth: false }
        },
        {
          path: 'adherence-report',
          name: 'DemoAdherenceReport',
          component: DemoAdherenceReport,
          meta: { requiresAuth: false }
        },
        {
          path: 'curve-results',
          name: 'DemoCurveResults',
          component: DemoCurveResults,
          meta: { requiresAuth: false }
        },
        {
          path: 'histogram-results',
          name: 'DemoHistogramResults',
          component: DemoTempMotionResults,
          meta: { requiresAuth: false }
        }
      ]
    },
    {
      path: '/maptac/:labId',
      component: LabLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'login',
          name: 'LoginLab',
          component: Login,
          meta: { requiresAuth: false }
        },
        {
          path: '',
          name: 'UploadChoice',
          component: UploadChoice
        },
        {
          path: 'upload/subject',
          name: 'SingleFileUpload',
          component: SingleFileUpload
        },
        {
          path: 'upload/cohort',
          name: 'CohortUpload',
          component: CohortUpload
        },
        {
          path: 'cohort-dashboard',
          name: 'CohortDashboard',
          component: CohortDashboard
        },
        {
          path: 'subject-dashboard',
          name: 'SubjectDashboard',
          component: SubjectDashboard
        },
        {
          path: 'explorer',
          name: 'Explorer',
          component: Explorer
        },
        {
          path: 'adherence-report',
          name: 'AdherenceReport',
          component: AdherenceReport
        },
        {
          path: 'curve-results',
          name: 'CurveResults',
          component: CurveResults
        },
        {
          path: 'histogram-results',
          name: 'HistogramResults',
          component: TempMotionResults
        },
        {
          path: 'completed-jobs',
          name: 'CompletedJobs',
          component: CompletedJobs
        },
        {
          path: 'billing',
          name: 'Billing',
          component: Billing
        },
        {
          path: 'set-lab-defaults',
          name: 'SetLabDefaults',
          component: SetLabDefaults
        },
        // Legacy Duo redirect_uri: /maptac/:labId/auth/callback (older templates used /:labId/auth/callback; guard rewrites)
        {
          path: 'auth/callback',
          name: 'SSOCallbackLab',
          component: SSOCallback,
          meta: { requiresAuth: false }
        }
      ]
    }
  ]
})

// Auth guard runs legacy / -> /maptac/ rewrites first (see createAuthGuard + getLegacyToMaptacLocation)
router.beforeEach(createAuthGuard())

// Create and mount the app
const app = createApp(App)
app.use(router)
app.mount('#app')
